/* Jumper v2 product page (templates/product.jumper-v2.json).
   One file for every jv2-* section. All product data comes from the
   [data-jv2-data] JSON that sections/jv2-main.liquid prints. */
(function () {
  'use strict';
  if (window.__jv2) return;
  window.__jv2 = true;

  /* ---------- Analytics ---------- */
  // Every event goes to dataLayer, a DOM event, and Shopify customer events
  // (Shopify.analytics.publish) so Intelligems or any pixel can pick it up.
  function track(name, detail) {
    var payload = Object.assign({ event: 'jv2_' + name, jv2_template: 'jumper-v2' }, detail || {});
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('jv2:track', { detail: payload })); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('jv2_' + name, detail || {}); } catch (e) {}
  }
  window.jv2Track = track;

  function initSectionViews() {
    var els = document.querySelectorAll('[data-jv2-section]');
    if (!('IntersectionObserver' in window) || !els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        track('section_view', { section: en.target.getAttribute('data-jv2-section') });
        io.unobserve(en.target);
      });
    }, { threshold: 0.35 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Helpers ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function scrollToEl(el, block) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: block || 'start' });
  }
  function handleize(s) {
    return String(s || '').toLowerCase().trim().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function lc(s) { return String(s || '').toLowerCase().trim(); }

  function formatMoney(cents, format, strip) {
    var value = '';
    var fmt = format || '${{amount}}';
    function delim(n, prec, th, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      default: value = delim(cents, 2, ',', '.');
    }
    var out = fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]+>/g, '');
    if (strip) out = out.replace(strip, '');
    return out;
  }

  /* ---------- Cart ---------- */
  var cartTotal = null;
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = c.total_price; document.dispatchEvent(new CustomEvent('jv2:cart', { detail: c })); return c; })
      .catch(function () {});
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
        return j;
      });
    }).then(function (j) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
      openCart();
      fetchCart();
      return j;
    });
  }
  function openCart() {
    try {
      if (typeof window.upcartOpenCart === 'function') return window.upcartOpenCart();
      if (window.UpCart && typeof window.UpCart.open === 'function') return window.UpCart.open();
      if (window.upcart && typeof window.upcart.open === 'function') return window.upcart.open();
    } catch (e) {}
    var drawer = document.querySelector('cart-drawer, cart-notification');
    if (drawer && typeof drawer.open === 'function') return drawer.open();
    window.location.href = '/cart';
  }

  /* ---------- Main buy box ---------- */
  function Main(root) {
    var dataEl = root.querySelector('[data-jv2-data]');
    if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var self = this;
    this.root = root;
    this.D = D;
    this.restricted = lc(D.restrictedSize);
    this.allow = D.allow.map(lc);
    var init = D.variants.find(function (v) { return v.id === D.initVariant; }) || D.variants[0];
    this.color = init.c;
    this.size = init.s;
    this.kitOn = false;
    this.addons = {};
    D.addons.forEach(function (a) { self.addons[a.block] = { cfg: a, on: false, variant: null }; });

    this.els = {
      track: root.querySelector('[data-jv2-track]'),
      countI: root.querySelector('[data-jv2-count-i]'),
      countN: root.querySelector('[data-jv2-count-n]'),
      colorName: root.querySelector('[data-jv2-color-name]'),
      swatches: root.querySelectorAll('[data-jv2-color]'),
      pills: root.querySelectorAll('[data-jv2-size]'),
      switchnote: root.querySelector('[data-jv2-switchnote]'),
      price: root.querySelector('[data-jv2-price]'),
      compare: root.querySelector('[data-jv2-compare]'),
      kit: root.querySelector('[data-jv2-kit]'),
      kitToggle: root.querySelector('[data-jv2-kit-toggle]'),
      kitPrice: root.querySelector('[data-jv2-kit-price]'),
      kitSave: root.querySelector('[data-jv2-kit-save]'),
      addonWrap: root.querySelector('[data-jv2-addons]'),
      bundleNote: root.querySelector('[data-jv2-bundle-note]'),
      ship: root.querySelector('[data-jv2-ship]'),
      atc: root.querySelector('[data-jv2-atc]'),
      atcLabel: root.querySelector('[data-jv2-atc-label]'),
      error: root.querySelector('[data-jv2-error]'),
      sticky: root.querySelector('[data-jv2-sticky]'),
      stickyDot: root.querySelector('[data-jv2-sticky-dot]'),
      stickySize: root.querySelector('[data-jv2-sticky-size]'),
      stickyPrice: root.querySelector('[data-jv2-sticky-price]'),
      stickyAtc: root.querySelector('[data-jv2-sticky-atc]')
    };

    this.bind();
    this.render(false);
    this.initCounter();
    this.initSticky();
    fetchCart().then(function () { self.renderShip(); });
    document.addEventListener('jv2:cart', function () { self.renderShip(); });
    document.addEventListener('cart:updated', function (e) { if (!e.detail) fetchCart(); });
    window.jv2Main = this;
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('square-placement').then(function () { self.render(false); }).catch(function () {});
    }
  }

  Main.prototype.money = function (c) { return formatMoney(c, this.D.moneyFormat, this.D.ccStrip); };
  Main.prototype.isHidden = function (c) { return this.D.hidden.indexOf('|' + lc(c) + '|') > -1; };
  Main.prototype.variantFor = function (c, s) {
    return this.D.variants.find(function (v) { return v.c === c && v.s === s; }) || null;
  };
  Main.prototype.colorOk = function (c, s) {
    if (this.isHidden(c)) return false;
    if (this.restricted && lc(s) === this.restricted && this.allow.indexOf(lc(c)) === -1) return false;
    var v = this.variantFor(c, s);
    return !!(v && v.a);
  };
  Main.prototype.colorsFor = function (s) {
    var self = this;
    return this.D.colors.map(function (c) { return c.name; }).filter(function (c) { return self.colorOk(c, s); });
  };
  Main.prototype.current = function () { return this.variantFor(this.color, this.size); };
  Main.prototype.kitVariant = function () {
    var k = this.D.kit[lc(this.color) + '|' + lc(this.size)];
    return k && k.a ? k : null;
  };

  Main.prototype.bind = function () {
    var self = this;
    this.els.swatches.forEach(function (b) {
      b.addEventListener('click', function () { self.setColor(b.getAttribute('data-jv2-color'), 'swatch'); });
    });
    this.els.pills.forEach(function (b) {
      b.addEventListener('click', function () { self.setSize(b.getAttribute('data-jv2-size')); });
    });
    // Arrow keys move through a radiogroup.
    this.root.querySelectorAll('[role="radiogroup"]').forEach(function (g) {
      g.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
        var items = Array.prototype.filter.call(g.querySelectorAll('[role="radio"]'), function (x) { return !x.hidden; });
        var i = items.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var n = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length];
        n.focus(); n.click();
      });
    });
    if (this.els.kitToggle) {
      this.els.kitToggle.addEventListener('change', function () {
        self.kitOn = self.els.kitToggle.checked;
        if (self.kitOn) track('kit_selected', self.ctx());
        else track('kit_deselected', self.ctx());
        self.render(true);
      });
    }
    this.root.querySelectorAll('[data-jv2-addon]').forEach(function (wrap) {
      var id = wrap.getAttribute('data-jv2-addon');
      var st = self.addons[id];
      if (!st) return;
      var toggle = wrap.querySelector('[data-jv2-addon-toggle]');
      var colors = self.root.querySelector('[data-jv2-addon-colors="' + id + '"]');
      toggle.addEventListener('change', function () {
        st.on = toggle.checked;
        if (colors) colors.hidden = !st.on;
        if (st.on) track(st.cfg.event || 'addon_selected', Object.assign({ addon: st.cfg.handle }, self.ctx()));
        self.render(true);
      });
      if (colors) {
        var sw = colors.querySelectorAll('[data-jv2-addon-variant]');
        sw.forEach(function (b) {
          b.addEventListener('click', function () {
            st.variant = Number(b.getAttribute('data-jv2-addon-variant'));
            sw.forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
            var nm = colors.querySelector('[data-jv2-addon-color-name]');
            if (nm) nm.textContent = b.getAttribute('data-name');
            self.render(true);
          });
        });
        if (sw[0]) {
          st.variant = Number(sw[0].getAttribute('data-jv2-addon-variant'));
          sw[0].setAttribute('aria-checked', 'true');
          var nm0 = colors.querySelector('[data-jv2-addon-color-name]');
          if (nm0) nm0.textContent = sw[0].getAttribute('data-name');
        }
      }
    });
    this.els.atc.addEventListener('click', function () { self.addToCart('buy_box'); });
    if (this.els.stickyAtc) this.els.stickyAtc.addEventListener('click', function () {
      track('sticky_add_to_cart', self.ctx());
      self.addToCart('sticky');
    });
    this.root.querySelectorAll('[data-jv2-play]').forEach(playButton);
  };

  Main.prototype.ctx = function () {
    var v = this.current();
    return { color: this.color, size: this.size, variant_id: v ? v.id : null, kit: this.kitOn };
  };

  Main.prototype.setColor = function (c, source) {
    if (!c) return;
    if (!this.colorOk(c, this.size)) {
      // Asked for a color the current size doesn't come in (color rail): fall back to a size that has it.
      var self = this;
      var s = this.D.variants.filter(function (v) { return v.c === c; }).map(function (v) { return v.s; })
        .find(function (sz) { return self.colorOk(c, sz); });
      if (!s) return;
      this.size = s;
    }
    this.color = c;
    if (this.els.switchnote) this.els.switchnote.hidden = true;
    this.render(true);
    if (source) track('color_selected', Object.assign({ source: source }, this.ctx()));
  };

  Main.prototype.setSize = function (s) {
    if (s === this.size) return;
    this.size = s;
    var note = this.els.switchnote || document.createElement('p');
    note.hidden = true;
    if (!this.colorOk(this.color, s)) {
      var list = this.colorsFor(s);
      var pick = list.find(function (c) { return lc(c) === lc(this.D.defaultLargeColor); }, this) || list[0];
      if (pick) {
        this.color = pick;
        var names = list.length > 1 ? list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1] : list[0];
        note.textContent = (this.D.switchCopy || '[colors]').replace('[colors]', names);
        note.hidden = false;
      }
    }
    track('size_toggled', this.ctx());
    this.render(true);
  };

  Main.prototype.render = function (userChange) {
    var self = this;
    if (userChange) this.justAdded = false;
    var v = this.current();

    // Swatches: hide colors this size doesn't come in.
    this.els.swatches.forEach(function (b) {
      var c = b.getAttribute('data-jv2-color');
      b.hidden = !self.colorOk(c, self.size);
      b.setAttribute('aria-checked', String(c === self.color));
      b.tabIndex = c === self.color ? 0 : -1;
    });
    this.els.pills.forEach(function (b) {
      var s = b.getAttribute('data-jv2-size');
      b.setAttribute('aria-checked', String(s === self.size));
      b.tabIndex = s === self.size ? 0 : -1;
    });
    this.els.colorName.textContent = this.color;
    var cc = this.root.querySelector('[data-jv2-color-count]');
    if (cc) {
      var n = this.colorsFor(this.size).length;
      cc.textContent = n > 1 ? n + ' colors' : '';
    }
    this.root.querySelectorAll('[data-jv2-color-desc]').forEach(function (p) {
      p.hidden = p.getAttribute('data-jv2-color-desc') !== self.color;
    });

    // Price.
    if (v) {
      this.els.price.textContent = v.pf;
      this.els.compare.hidden = !(v.cp > v.p);
      if (v.cp > v.p) this.els.compare.textContent = v.cpf;
    }

    // Kit.
    var kv = this.kitVariant();
    if (this.els.kit) {
      this.els.kit.hidden = !kv;
      if (!kv && this.kitOn) { this.kitOn = false; this.els.kitToggle.checked = false; }
      if (kv) {
        this.els.kitPrice.textContent = kv.pf;
        var parts = v ? v.p : 0;
        Object.keys(this.addons).forEach(function (k) {
          var a = self.addons[k];
          if (!a.cfg.inKit) return;
          var av = self.addonVariant(a);
          if (av) parts += av.p;
        });
        var save = parts - kv.p;
        this.els.kitSave.hidden = !(save > 0);
        if (save > 0) this.els.kitSave.textContent = 'You save ' + this.money(save);
      }
      this.els.kit.classList.toggle('is-on', this.kitOn);
    }

    // Add-ons: only without the kit.
    this.root.querySelectorAll('[data-jv2-addon]').forEach(function (wrap) {
      var st = self.addons[wrap.getAttribute('data-jv2-addon')];
      if (!st) return;
      var av = self.addonVariant(st);
      wrap.hidden = self.kitOn || !av;
      if (av) {
        var pe = wrap.querySelector('[data-jv2-addon-price]');
        if (pe) pe.textContent = av.pf;
        var se = wrap.querySelector('[data-jv2-addon-size]');
        if (se) se.textContent = st.cfg.matchSize ? '(' + av.t + ')' : '';
      }
      wrap.classList.toggle('is-on', st.on && !self.kitOn);
    });

    // Bundle note: kit price applied, or one item away from it.
    var P = this.plan();
    if (this.els.bundleNote) {
      var bc = this.D.bundleCopy || {};
      var note = '';
      if (P.useKit) note = (bc.save || '').replace('[kit]', bc.kitName || 'Kit').replace('[amount]', this.money(P.sep - P.total));
      else if (P.nudge) note = (bc.nudge || '').replace('[item]', P.nudge.title).replace('[kit]', bc.kitName || 'kit').replace('[amount]', this.money(P.nudge.save));
      else if (P.intro) note = (bc.intro || '').replace('[items]', P.intro.titles).replace('[kit]', bc.kitName || 'kit').replace('[amount]', this.money(P.intro.save));
      this.els.bundleNote.textContent = note;
      this.els.bundleNote.hidden = !note;
      this.els.bundleNote.classList.toggle('is-applied', P.useKit);
    }

    // Add to cart.
    var total = this.selectionTotal();
    var sellable = this.kitOn ? !!kv : !!(v && v.a);
    this.els.atc.disabled = !sellable;
    this.els.atcLabel.textContent = sellable ? 'Add to cart · ' + this.money(total) : 'Sold out';
    if (this.els.stickyAtc) this.els.stickyAtc.disabled = !sellable;

    // Afterpay: keep its installment amount on the current total, and use the small size.
    this.root.querySelectorAll('square-placement, afterpay-placement').forEach(function (pl) {
      if (pl.getAttribute('data-size') !== 'sm') pl.setAttribute('data-size', 'sm');
      var amt = (total / 100).toFixed(2);
      if (pl.getAttribute('data-amount') !== amt) pl.setAttribute('data-amount', amt);
    });

    // Sticky bar.
    if (this.els.sticky) {
      var col = this.D.colors.find(function (c) { return c.name === self.color; });
      var sw = this.root.querySelector('[data-jv2-color="' + CSS.escape(this.color) + '"]');
      this.els.stickyDot.style.background = sw ? getComputedStyle(sw).getPropertyValue('--sw') : (col ? col.hex : '');
      this.els.stickySize.textContent = this.color + (this.size ? ' · ' + this.size : '') + (this.kitOn ? ' · Kit' : '');
      this.els.stickyPrice.textContent = this.money(total);
    }

    this.renderGallery(userChange);
    this.renderShip();

    if (userChange && v) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('jv2:variant', { detail: this.ctx() }));
    }
  };

  Main.prototype.addonVariant = function (st) {
    var vs = st.cfg.variants.filter(function (x) { return x.a; });
    if (st.cfg.matchSize) {
      var s = lc(this.size);
      return vs.find(function (x) { return lc(x.t) === s || lc(x.t).indexOf(s) > -1; }) || null;
    }
    if (st.cfg.pickColor && st.variant) return vs.find(function (x) { return x.id === st.variant; }) || vs[0] || null;
    return vs[0] || null;
  };

  Main.prototype.selectionTotal = function () {
    if (this.kitOn) { var k = this.kitVariant(); return k ? k.p : 0; }
    return this.plan().total;
  };

  // What goes in the cart for the current pick. When every "Part of the kit" add-on is
  // picked and a kit variant exists for this color and size, the bag and those add-ons
  // are replaced by the kit variant (only if that is not more expensive).
  Main.prototype.plan = function () {
    var self = this;
    var bag = this.current();
    var list = Object.keys(this.addons).map(function (k) { return self.addons[k]; });
    var picked = list.filter(function (a) { return a.on && self.addonVariant(a); });
    var kitItems = list.filter(function (a) { return a.cfg.inKit && self.addonVariant(a); });
    var kit = this.kitVariant();
    var price = function (a) { return self.addonVariant(a).p; };
    var sep = (bag ? bag.p : 0) + picked.reduce(function (t, a) { return t + price(a); }, 0);
    var kitParts = (bag ? bag.p : 0) + kitItems.reduce(function (t, a) { return t + price(a); }, 0);
    var lines = [], total = sep, useKit = false, nudge = null;
    if (kit && kitItems.length && kitItems.every(function (a) { return a.on; }) && kit.p <= kitParts) {
      useKit = true;
      lines.push({ id: kit.id, quantity: 1 });
      picked.forEach(function (a) { if (!a.cfg.inKit) lines.push({ id: self.addonVariant(a).id, quantity: 1 }); });
      total = sep - kitParts + kit.p;
    } else {
      if (bag) lines.push({ id: bag.id, quantity: 1 });
      picked.forEach(function (a) { lines.push({ id: self.addonVariant(a).id, quantity: 1 }); });
      var missing = kitItems.filter(function (a) { return !a.on; });
      if (kit && kitItems.length > 1 && missing.length === 1 && kitParts - kit.p > 0) {
        nudge = { title: missing[0].cfg.title, save: kitParts - kit.p };
      }
      // Nothing from the kit picked yet: show the saving up front.
      if (kit && kitItems.length > 1 && missing.length === kitItems.length && kitParts - kit.p > 0) {
        var intro = { titles: kitItems.map(function (a) { return a.cfg.title; }).join(' + '), save: kitParts - kit.p };
      }
    }
    return { lines: lines, total: total, sep: sep, useKit: useKit, nudge: nudge, intro: intro || null, picked: picked };
  };

  Main.prototype.renderShip = function () {
    var el = this.els.ship;
    if (!el || !this.D.threshold) return;
    if (this.kitOn) { el.hidden = true; return; }
    el.hidden = false;
    // What is already in the cart plus what is selected here. Right after an add,
    // the selection is already in the cart, so it isn't counted twice.
    var inCart = cartTotal || 0;
    var have = inCart + (this.justAdded ? 0 : this.selectionTotal());
    var left = this.D.threshold - have;
    var C = this.D.shipCopy;
    if (inCart >= this.D.threshold) {
      el.textContent = C.done || '';           // already free in the cart
    } else if (left <= 0) {
      el.textContent = C.order || C.done || ''; // this pick gets there
    } else {
      el.textContent = (C.away || '').replace('[amount]', this.money(left));
    }
    el.classList.toggle('is-done', left <= 0);
  };

  Main.prototype.renderGallery = function (userChange) {
    var track_ = this.els.track;
    if (!track_) return;
    var ch = handleize(this.color);
    var large = !!this.restricted && lc(this.size) === this.restricted;
    var slides = Array.prototype.slice.call(track_.querySelectorAll('.jv2-slide'));
    var hasLarge = large && slides.some(function (s) { return s.dataset.color === ch && s.dataset.size === 'large'; });
    var want = hasLarge ? 'large' : 'any';
    var shown = 0;
    var max = this.D.maxSlides || 12;
    // Product videos (data-rank 99) can be moved up to sit after the first N photos of this color
    // (section setting "Product videos: show after this many photos"). They count toward the max.
    var pos = this.D.videoPos || 0;
    if (pos > 0) {
      var vids = slides.filter(function (s) { return s.dataset.rank === '99'; });
      var photos = slides.filter(function (s) { return s.dataset.rank !== '99' && (s.dataset.color === '*' || (s.dataset.color === ch && s.dataset.size === want)); });
      var anchor = photos[pos];
      if (vids.length && anchor) {
        vids.forEach(function (v) { track_.insertBefore(v, anchor); });
        slides = Array.prototype.slice.call(track_.querySelectorAll('.jv2-slide'));
      }
    }
    slides.forEach(function (s) {
      var ok = s.dataset.color === '*' || (s.dataset.color === ch && s.dataset.size === want);
      if (ok && shown >= max) ok = false;
      if (ok) shown++;
      s.hidden = !ok;
    });
    if (userChange) track_.scrollTo({ left: 0, behavior: 'auto' });
    this.updateCount();
  };

  Main.prototype.initCounter = function () {
    var self = this;
    var t = this.els.track;
    if (!t) return;
    var raf = 0;
    t.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; self.updateCount(); });
    }, { passive: true });
    this.updateCount();
  };
  Main.prototype.updateCount = function () {
    var t = this.els.track;
    var vis = Array.prototype.filter.call(t.querySelectorAll('.jv2-slide'), function (s) { return !s.hidden; });
    var idx = 0;
    var left = t.getBoundingClientRect().left;
    var best = Infinity;
    vis.forEach(function (s, i) {
      var d = Math.abs(s.getBoundingClientRect().left - left);
      if (d < best) { best = d; idx = i; }
    });
    if (this.els.countI) this.els.countI.textContent = vis.length ? idx + 1 : 0;
    if (this.els.countN) this.els.countN.textContent = vis.length;
  };

  Main.prototype.initSticky = function () {
    var bar = this.els.sticky;
    if (!bar) return;
    var atc = this.els.atc;
    var shown = null;
    var raf = 0;
    // Show once the main button has scrolled up out of view, not before it.
    function check() {
      raf = 0;
      var show = atc.getBoundingClientRect().bottom < 0;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('jv2-sticky-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    check();
  };

  Main.prototype.addToCart = function (source) {
    var self = this;
    var v = this.current();
    var items, P = null;
    if (this.kitOn) {
      var k = this.kitVariant();
      if (!k) return;
      items = [{ id: k.id, quantity: 1 }];
    } else {
      if (!v || !v.a) return;
      P = this.plan();
      items = P.lines;
    }
    var addonHandles = P ? P.picked.map(function (a) { return a.cfg; }) : [];
    var btns = [this.els.atc, this.els.stickyAtc].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    this.els.error.hidden = true;
    addItems(items).then(function () {
      self.justAdded = true;
      track('add_to_cart', Object.assign({ source: source, items: items.length, kit_price: !!(P && P.useKit), value: (P ? P.total : 0) / 100 }, self.ctx()));
      if (P && P.useKit) track('kit_selected', Object.assign({ source: 'bundle_tiles' }, self.ctx()));
      addonHandles.forEach(function (cfg) {
        track((cfg.event || 'addon') .replace(/_selected$/, '') + '_added', Object.assign({ addon: cfg.handle }, self.ctx()));
      });
    }).catch(function (err) {
      self.els.error.textContent = err.message;
      self.els.error.hidden = false;
    }).then(function () {
      btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
      self.render(false);
    });
  };

  /* ---------- Bundle builder (sections/jv2-bundle.liquid) ---------- */
  function Bundle(root) {
    var m = window.jv2Main;
    var dataEl = root.querySelector('[data-jv2-bundle-data]');
    if (!m || !dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var self = this;
    this.m = m; this.root = root; this.D = D; this.justAdded = false;
    this.items = D.items.map(function (cfg) {
      var el = root.querySelector('[data-jv2-bundle-item="' + cfg.block + '"]');
      return { cfg: cfg, el: el, toggle: el.querySelector('[data-jv2-bundle-toggle]'), colors: el.querySelector('[data-jv2-bundle-colors]'), variant: null };
    });
    this.els = {
      bagImg: root.querySelector('[data-jv2-bundle-bag-img]'),
      bagMeta: root.querySelector('[data-jv2-bundle-bag-meta]'),
      bagPrice: root.querySelector('[data-jv2-bundle-bag-price]'),
      nudge: root.querySelector('[data-jv2-bundle-nudge]'),
      was: root.querySelector('[data-jv2-bundle-was]'),
      total: root.querySelector('[data-jv2-bundle-total]'),
      save: root.querySelector('[data-jv2-bundle-save]'),
      bar: root.querySelector('[data-jv2-bundle-bar]'),
      ship: root.querySelector('[data-jv2-bundle-ship]'),
      add: root.querySelector('[data-jv2-bundle-add]'),
      addLabel: root.querySelector('[data-jv2-bundle-add-label]'),
      error: root.querySelector('[data-jv2-bundle-error]')
    };
    this.items.forEach(function (it) {
      it.toggle.addEventListener('change', function () {
        if (it.colors) it.colors.hidden = !it.toggle.checked;
        if (it.toggle.checked) track(it.cfg.event || 'bundle_item_selected', Object.assign({ item: it.cfg.handle, source: 'bundle' }, m.ctx()));
        self.justAdded = false;
        self.render();
      });
      if (it.colors) {
        var sw = it.colors.querySelectorAll('[data-jv2-bundle-variant]');
        var pick = function (b) {
          it.variant = Number(b.getAttribute('data-jv2-bundle-variant'));
          sw.forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
          it.colors.querySelector('[data-jv2-bundle-color-name]').textContent = b.getAttribute('data-name');
        };
        sw.forEach(function (b) { b.addEventListener('click', function () { pick(b); self.render(); }); });
        if (sw[0]) pick(sw[0]);
        it.colors.hidden = !it.toggle.checked;
      }
    });
    this.els.add.addEventListener('click', function () { self.add(); });
    document.addEventListener('jv2:variant', function () { self.justAdded = false; self.render(); });
    document.addEventListener('jv2:cart', function () { self.render(); });
    this.render();
  }

  Bundle.prototype.variantFor = function (it) {
    var vs = it.cfg.variants.filter(function (x) { return x.a; });
    if (it.cfg.matchSize) {
      var s = lc(this.m.size);
      return vs.find(function (x) { return lc(x.t) === s || lc(x.t).indexOf(s) > -1; }) || null;
    }
    if (it.cfg.pickColor && it.variant) return vs.find(function (x) { return x.id === it.variant; }) || null;
    return vs[0] || null;
  };

  // Works out what goes in the cart and what it costs.
  Bundle.prototype.plan = function () {
    var self = this, m = this.m;
    var bag = m.current();
    var picked = this.items.filter(function (it) { return it.toggle.checked && self.variantFor(it); });
    var kitItems = this.items.filter(function (it) { return it.cfg.inKit && self.variantFor(it); });
    var kit = m.kitVariant();
    var sep = (bag ? bag.p : 0) + picked.reduce(function (t, it) { return t + self.variantFor(it).p; }, 0);
    var allKit = kit && kitItems.length > 0 && kitItems.every(function (it) { return it.toggle.checked; });
    var lines = [], total = sep, useKit = false;
    if (allKit) {
      var kitParts = (bag ? bag.p : 0) + kitItems.reduce(function (t, it) { return t + self.variantFor(it).p; }, 0);
      if (kit.p <= kitParts) {
        useKit = true;
        lines.push({ id: kit.id, quantity: 1 });
        picked.forEach(function (it) { if (!it.cfg.inKit) lines.push({ id: self.variantFor(it).id, quantity: 1 }); });
        total = sep - kitParts + kit.p;
      }
    }
    if (!useKit) {
      if (bag) lines.push({ id: bag.id, quantity: 1 });
      picked.forEach(function (it) { lines.push({ id: self.variantFor(it).id, quantity: 1 }); });
    }
    // Nudge when exactly one kit item is missing and finishing the kit saves money.
    var missing = kitItems.filter(function (it) { return !it.toggle.checked; });
    var nudge = null;
    if (kit && !useKit && missing.length === 1 && kitItems.length > 1) {
      var withIt = sep + self.variantFor(missing[0]).p;
      var kitParts2 = (bag ? bag.p : 0) + kitItems.reduce(function (t, it) { return t + self.variantFor(it).p; }, 0);
      var saveIfDone = kitParts2 - kit.p;
      if (saveIfDone > 0) nudge = { item: missing[0], save: saveIfDone, total: withIt - saveIfDone };
    }
    return { bag: bag, picked: picked, lines: lines, total: total, sep: sep, useKit: useKit, nudge: nudge, sellable: !!(bag && bag.a) };
  };

  Bundle.prototype.render = function () {
    var self = this, m = this.m, e = this.els;
    var P = this.plan();
    // Thumbnail: the front product shot for this color when there is one.
    var slide = m.els.track && (m.els.track.querySelector('.jv2-slide[data-rank="1"]:not([hidden]) img') || m.els.track.querySelector('.jv2-slide:not([hidden]) img'));
    if (slide && e.bagImg) { var src = slide.currentSrc || slide.src; if (e.bagImg.getAttribute('src') !== src) e.bagImg.src = src; }
    e.bagMeta.textContent = m.color + ' · ' + m.size;
    e.bagPrice.textContent = P.bag ? P.bag.pf : '';
    this.items.forEach(function (it) {
      var v = self.variantFor(it);
      it.el.hidden = !v;
      it.el.classList.toggle('is-on', it.toggle.checked && !!v);
      if (v) {
        it.el.querySelector('[data-jv2-bundle-price]').textContent = v.pf;
        var sz = it.el.querySelector('[data-jv2-bundle-size]');
        if (sz) sz.textContent = it.cfg.matchSize ? '(' + v.t + ')' : '';
      }
      var on = it.toggle.checked && !!v;
      var th = self.root.querySelector('[data-jv2-bundle-thumb="' + it.cfg.block + '"]');
      var pl = self.root.querySelector('[data-jv2-bundle-plus="' + it.cfg.block + '"]');
      if (th) th.hidden = !on;
      if (pl) pl.hidden = !on;
    });
    e.total.textContent = m.money(P.total);
    e.was.hidden = !P.useKit;
    if (P.useKit) e.was.textContent = m.money(P.sep);
    e.save.hidden = !P.useKit;
    if (P.useKit) e.save.textContent = (this.D.saveText || '').replace('[amount]', m.money(P.sep - P.total));
    e.nudge.hidden = !P.nudge;
    if (P.nudge) {
      e.nudge.textContent = (this.D.nudge || '').replace('[item]', P.nudge.item.cfg.title).replace('[kit]', this.D.kitName || 'kit').replace('[amount]', m.money(P.nudge.save));
    }
    // Free shipping progress, counting the cart plus this bundle.
    if (e.ship && m.D.threshold) {
      var have = (cartTotal || 0) + (this.justAdded ? 0 : P.total);
      var pct = Math.min(100, Math.round(have / m.D.threshold * 100));
      e.bar.style.width = pct + '%';
      var left = m.D.threshold - have;
      e.ship.textContent = left > 0 ? (m.D.shipCopy.away || '').replace('[amount]', m.money(left)) : (m.D.shipCopy.done || '');
      e.ship.parentNode.classList.toggle('is-done', left <= 0);
    }
    e.add.disabled = !P.sellable;
    if (!this.justAdded) e.addLabel.textContent = P.sellable ? this.D.buttonLabel + ' · ' + m.money(P.total) : 'Sold out';
  };

  Bundle.prototype.add = function () {
    var self = this, e = this.els;
    var P = this.plan();
    if (!P.sellable || !P.lines.length) return;
    e.add.disabled = true; e.add.setAttribute('aria-busy', 'true'); e.error.hidden = true;
    addItems(P.lines).then(function () {
      self.justAdded = true;
      e.addLabel.textContent = self.D.addedLabel || 'Added';
      track('bundle_added', Object.assign({ items: P.picked.map(function (it) { return it.cfg.handle; }), kit: P.useKit, value: P.total / 100 }, self.m.ctx()));
      if (P.useKit) track('kit_selected', Object.assign({ source: 'bundle' }, self.m.ctx()));
      P.picked.forEach(function (it) {
        track((it.cfg.event || 'bundle_item').replace(/_selected$/, '') + '_added', Object.assign({ item: it.cfg.handle, source: 'bundle' }, self.m.ctx()));
      });
    }).catch(function (err) {
      e.error.textContent = err.message; e.error.hidden = false;
    }).then(function () {
      e.add.removeAttribute('aria-busy');
      self.render();
    });
  };

  /* ---------- Video: poster until tapped ---------- */
  function playButton(btn) {
    btn.addEventListener('click', function () {
      var tt = btn.getAttribute('data-tiktok');
      if (tt) {
        // TikTok's own embed player; nothing from TikTok loads until this tap.
        var f = document.createElement('iframe');
        f.src = 'https://www.tiktok.com/player/v1/' + encodeURIComponent(tt) + '?autoplay=1&loop=1&rel=0&description=0&music_info=0';
        f.className = 'jv2-video';
        f.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        f.title = btn.getAttribute('aria-label') || 'TikTok video';
        btn.replaceWith(f);
        track(btn.getAttribute('data-jv2-track-name') || 'video_play', { tiktok: tt });
        return;
      }
      var src = btn.getAttribute('data-src');
      if (!src) return;
      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      if (btn.hasAttribute('data-muted')) v.muted = true;
      if (btn.hasAttribute('data-loop')) v.loop = true;
      v.className = 'jv2-video';
      var img = btn.querySelector('img');
      if (img) v.poster = img.currentSrc || img.src;
      btn.replaceWith(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      track(btn.getAttribute('data-jv2-track-name') || 'video_play', { src: src.split('/').pop() });
    });
  }

  /* ---------- Fit checker ---------- */
  function initFit(root) {
    var sel = root.querySelector('[data-jv2-fit-select]');
    var out = root.querySelector('[data-jv2-fit-result]');
    if (!sel || !out) return;
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var r = o ? o.getAttribute('data-result') : '';
      out.textContent = r || '';
      out.hidden = !r;
      out.setAttribute('data-state', o ? o.getAttribute('data-kind') || '' : '');
      if (o && o.value) track('fit_checker_used', { item: o.text, result: o.getAttribute('data-kind') });
    });
  }

  /* ---------- Rain cover button (story sections) ---------- */
  function initRainButtons() {
    document.querySelectorAll('[data-jv2-add-variants]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var map = {};
        try { map = JSON.parse(btn.getAttribute('data-jv2-add-variants')); } catch (e) {}
        var size = window.jv2Main ? lc(window.jv2Main.size) : '';
        var id = map[size] || map['*'] || Object.keys(map).map(function (k) { return map[k]; })[0];
        if (!id) return;
        btn.disabled = true;
        var label = btn.textContent;
        addItems([{ id: id, quantity: 1 }]).then(function () {
          track(btn.getAttribute('data-jv2-track-name') || 'rain_cover_added', { source: 'story', size: size });
          btn.textContent = btn.getAttribute('data-done') || label;
        }).catch(function (err) {
          btn.textContent = err.message;
        }).then(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------- Color rail ---------- */
  function initColorRail(root) {
    root.querySelectorAll('[data-jv2-pick-color]').forEach(function (card) {
      card.addEventListener('click', function () {
        var c = card.getAttribute('data-jv2-pick-color');
        track('color_card_tapped', { color: c });
        var m = window.jv2Main;
        if (m) {
          m.setColor(c, 'color_card');
          scrollToEl(m.root, 'start');
        }
      });
    });
  }

  /* ---------- Customer photos from Junip (sections/jv2-ugc.liquid) ---------- */
  // Uses the public Junip store key the Junip app already prints on the page.
  function initUgc(root) {
    var keyEl = document.querySelector('[data-store-key]');
    var key = keyEl && keyEl.getAttribute('data-store-key');
    var rail = root.querySelector('[data-jv2-ugc-rail]');
    if (!key || !rail) return;
    var max = Number(root.getAttribute('data-max')) || 12;
    var pid = root.getAttribute('data-product-id');
    var alt = root.getAttribute('data-alt') || '';
    var colors = (root.getAttribute('data-colors') || '').toLowerCase().split('|').filter(Boolean);
    var started = false;
    function load() {
      if (started) return;
      started = true;
      var items = [];
      var pages = 0;
      (function next(after) {
        var u = 'https://api.juniphq.com/v1/product_reviews?filter[product_remote_ids]=' + pid + '&page[size]=50&include=customer' + (after ? '&page[after]=' + after : '');
        fetch(u, { headers: { 'Junip-Store-Key': key } }).then(function (r) { return r.json(); }).then(function (j) {
          (j.product_reviews || []).forEach(function (r) {
            if (r.rating < 4 || !r.photo_urls || !r.photo_urls.length) return;
            // Only photos of colors that are on sale now (the color is in the review's variant title).
            var t = (r.target_title || '').toLowerCase();
            if (colors.length && !colors.some(function (c) { return t.indexOf(c) > -1; })) return;
            var c = r.customer || {};
            var name = r.respondent_display_name || ((c.first_name || '') + (c.last_name ? ' ' + c.last_name.charAt(0) + '.' : ''));
            items.push({ img: r.photo_urls[0].large || r.photo_urls[0].thumbnail, body: (r.body || '').replace(/\s+/g, ' ').trim(), name: name.trim() });
          });
          pages++;
          var after2 = j.meta && j.meta.page && j.meta.page.after;
          if (items.length < max && after2 && pages < 30) return next(after2);
          render(items.slice(0, max));
        }).catch(function () {});
      })(null);
    }
    function render(list) {
      if (list.length < 3) return;
      list.forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'jv2-ugc__item';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jv2-ugc__card';
        b.setAttribute('data-jv2-photos', '');
        var img = document.createElement('img');
        img.src = it.img; img.alt = alt; img.loading = 'lazy'; img.decoding = 'async'; img.width = 480; img.height = 600;
        var cap = document.createElement('span');
        cap.className = 'jv2-ugc__cap';
        var txt = it.body.length > 90 ? it.body.slice(0, 88).replace(/\s+\S*$/, '') + '…' : it.body;
        cap.textContent = '“' + txt + '”' + (it.name ? ' ' + it.name : '');
        b.appendChild(img); b.appendChild(cap); li.appendChild(b); rail.appendChild(li);
      });
      root.hidden = false;
      track('ugc_loaded', { photos: list.length });
    }
    // Fetch the review data once the page has finished loading; the photos themselves load lazily.
    function later() { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(load); }
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  }

  /* ---------- Reviews: photos filter ---------- */
  // Turns on Junip's own "Photos & videos" filter. Junip renders it inside its Filter
  // panel, so the panel is opened first when the toggle isn't on the page yet.
  function showPhotos() {
    var wrap = document.getElementById('jv2-reviews');
    if (!wrap) return;
    scrollToEl(wrap, 'start');
    var tries = 0;
    var opened = false;
    (function attempt() {
      var t = wrap.querySelector('[aria-label*="photos" i][aria-label*="filter" i]');
      if (t) {
        if (t.getAttribute('aria-checked') !== 'true') t.click();
        return;
      }
      if (!opened) {
        var f = wrap.querySelector('[aria-label="Toggle filters"]');
        if (f) { f.click(); opened = true; }
      }
      if (++tries < 20) setTimeout(attempt, 300);
    })();
  }
  window.jv2ShowPhotos = showPhotos;

  /* ---------- FAQ: one open video at a time is fine; nothing needed ---------- */

  /* ---------- Generic tracked clicks ---------- */
  function initDelegates() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-jv2-scroll-reviews]');
      if (a) {
        e.preventDefault();
        track('rating_tapped', {});
        scrollToEl(document.getElementById('jv2-reviews'), 'start');
        return;
      }
      var sz = e.target.closest('[data-jv2-goto-size]');
      if (sz) {
        var slide = document.querySelector('[data-jv2-size-ref]');
        var track_ = slide && slide.parentElement;
        if (slide && track_) {
          if (track_.scrollWidth > track_.clientWidth + 4) {
            track_.scrollTo({ left: slide.offsetLeft - track_.offsetLeft - parseFloat(getComputedStyle(track_).paddingLeft || 0), behavior: reduceMotion ? 'auto' : 'smooth' });
            scrollToEl(track_.closest('[data-jv2-gallery]'), 'start');
          } else {
            scrollToEl(slide, 'center');
          }
          track('size_video_link', {});
        }
        return;
      }
      var more = e.target.closest('[data-jv2-reviews-more]');
      if (more) {
        uncapReviews();
        track('reviews_see_all', {});
        return;
      }
      var p = e.target.closest('[data-jv2-photos]');
      if (p) {
        e.preventDefault();
        uncapReviews();
        track('customer_photos_tapped', {});
        showPhotos();
      }
    });
  }

  /* Phones show a few reviews first; "See all" (or the photos filter) shows the full list. */
  function uncapReviews() {
    var sec = document.getElementById('jv2-reviews');
    if (!sec) return;
    sec.classList.remove('jv2-reviews--capped');
    var b = sec.querySelector('[data-jv2-reviews-more]');
    if (b) b.remove();
  }

  function boot() {
    document.querySelectorAll('[data-jv2-main]').forEach(function (r) { if (!r.__jv2) { r.__jv2 = true; new Main(r); } });
    document.querySelectorAll('[data-jv2-bundle]').forEach(function (r) { if (!r.__jv2) { r.__jv2 = true; new Bundle(r); } });
    document.querySelectorAll('[data-jv2-fit]').forEach(initFit);
    document.querySelectorAll('[data-jv2-colors]').forEach(initColorRail);
    document.querySelectorAll('[data-jv2-ugc]').forEach(initUgc);
    document.querySelectorAll('[data-jv2-section]:not([data-jv2-main]) [data-jv2-play]').forEach(playButton);
    initRainButtons();
    initDelegates();
    initSectionViews();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-run when a section reloads.
  document.addEventListener('shopify:section:load', function () {
    window.__jv2 = true;
    document.querySelectorAll('[data-jv2-main]').forEach(function (r) { if (!r.__jv2) { r.__jv2 = true; new Main(r); } });
    document.querySelectorAll('[data-jv2-bundle]').forEach(function (r) { if (!r.__jv2) { r.__jv2 = true; new Bundle(r); } });
    document.querySelectorAll('[data-jv2-fit]').forEach(initFit);
    document.querySelectorAll('[data-jv2-colors]').forEach(initColorRail);
  });
})();
